import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LogRotinaService} from '../../service/log-rotina.service';
import {LogRotina} from '../../model/log-rotina.model';
import {TipoLog} from '../../enum/tipo-log.enum';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../../environments/environment';
import {AuthService} from '../../service/auth.service';
import {MatTooltip} from '@angular/material/tooltip';
import {DisparoAutomaticoService} from '../../service/disparo-automatico.service';
import {ProgramacaoDisparoService} from '../../service/programacao-disparo.service';

@Component({
  selector: 'app-modal-log-rotina',
  standalone: true,
  imports: [
    DatePipe,
    MatTooltip
  ],
  templateUrl: './modal-log-rotina.component.html',
  styleUrl: './modal-log-rotina.component.css'
})
export class ModalLogRotinaComponent implements OnInit {
  logs: LogRotina[] = [];

  private readonly dialogRef = inject(MatDialogRef<ModalLogRotinaComponent>);
  public data = inject<{ rotinaId?: number; disparoId?: number; programacaoId?: number }>(MAT_DIALOG_DATA);
  private readonly logRotinaService = inject(LogRotinaService);
  private readonly disparoAutomaticoService = inject(DisparoAutomaticoService);
  private readonly programacaoDisparoService = inject(ProgramacaoDisparoService);
  private readonly authService = inject(AuthService);

  ngOnInit() {
    if (this.data.programacaoId != null) {
      this.programacaoDisparoService.buscarLogs(this.data.programacaoId).subscribe({
        next: logs => this.logs = logs
      });
    } else if (this.data.disparoId != null) {
      this.disparoAutomaticoService.buscarLogsDisparosAutomaticos(this.data.disparoId).subscribe({
        next: logs => this.logs = logs
      });
    } else if (this.data.rotinaId != null) {
      this.buscarLogsPorRotinaId(this.data.rotinaId);
    }
  }

  buscarLogsPorRotinaId(rotinaId: number) {
    this.logRotinaService.buscarLogsPorRotinaId(rotinaId).subscribe({
      next: logRotina => this.logs = logRotina
    });
  }

  getSrcTipoLog(log: LogRotina): string {
    switch (log.tipo) {
      case TipoLog.CRIACAO:
        return './assets/icones/criacao.png';
      case TipoLog.EDICAO:
        return './assets/icones/EDICAO.png';
      case TipoLog.EXCLUIR:
        return './assets/icones/excluir.png';
      case TipoLog.ASSOCIACAO:
        return './assets/icones/associar.png';
      case TipoLog.DESASSOCIAR:
        return './assets/icones/desassociar.png';
      case TipoLog.PERMICAO:
        return './assets/icones/permitir.png';
      case TipoLog.REVOGAR:
        return './assets/icones/revogar.png';
      case TipoLog.TRANSFERENCIA:
        return './assets/icones/transferencia_icone.png';
      default:
        return '';
    }
  }

  getSrcImgUsuario(log: LogRotina): string {
    if (log.usuario.extensao) {
      return `${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/usuario-img/${log.usuario.uuid}.${log.usuario.extensao}`;
    } else {
      return './assets/icones/no-img-default.png';
    }
  }
}
